
import { computed, defineComponent } from 'vue';
import CampoNumericoMedida from '@/core/components/Tela/CampoNumericoMedida.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';

export default defineComponent({
  name: 'ProdutoPesoMedidas',
  props: {
    pesoEmbalagem: {
      type: Number,
      required: true,
    },
    pesoBruto: {
      type: Number,
      required: true,
    },
    pesoLiquido: {
      type: Number,
      required: true,
    },
    comprimento: {
      type: Number,
      required: true,
    },
    altura: {
      type: Number,
      required: true,
    },
    largura: {
      type: Number,
      required: true,
    },
    calculoParaVolume: {
      type: Number,
      required: true,
    },
  },
  components: {
    CampoNumericoMedida,
    CampoNumerico,
  },
  emits: ['update:pesoEmbalagem', 'update:pesoBruto', 'update:pesoLiquido',
    'update:comprimento', 'update:altura', 'update:largura', 'update:calculoParaVolume'],
  setup(props, { emit }) {
    const computedPesoEmbalagem = computed({
      get: () => props.pesoEmbalagem,
      set: (valor: number) => {
        emit('update:pesoEmbalagem', valor);
      },
    });

    const computedPesoBruto = computed({
      get: () => props.pesoBruto,
      set: (valor: number) => {
        emit('update:pesoBruto', valor);
      },
    });

    const computedPesoLiquido = computed({
      get: () => props.pesoLiquido,
      set: (valor: number) => {
        emit('update:pesoLiquido', valor);
      },
    });

    const computedComprimento = computed({
      get: () => props.comprimento,
      set: (valor: number) => {
        emit('update:comprimento', valor);
      },
    });

    const computedAltura = computed({
      get: () => props.altura,
      set: (valor: number) => {
        emit('update:altura', valor);
      },
    });

    const computedLargura = computed({
      get: () => props.largura,
      set: (valor: number) => {
        emit('update:largura', valor);
      },
    });

    const computedCalculoParaVolume = computed({
      get: () => props.calculoParaVolume,
      set: (valor: number) => {
        emit('update:calculoParaVolume', valor);
      },
    });

    return {
      props,
      computedPesoEmbalagem,
      computedPesoBruto,
      computedPesoLiquido,
      computedComprimento,
      computedAltura,
      computedLargura,
      computedCalculoParaVolume,
    };
  },
});
